/* Ship-today message. All time logic runs in the visitor's browser,
   converted to Central time, because Shopify caches rendered pages. */
(function () {
  var el = document.querySelector('[data-rf-ship]');
  if (!el) return;

  var TZ = 'America/Chicago';
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var closed = (el.dataset.closed || '').split(',').filter(Boolean);
  var cut = (el.dataset.cutoff || '15:00').split(':');
  var cutMin = (+cut[0]) * 60 + (+(cut[1] || 0));
  var countdownMin = (+el.dataset.countdown || 0) * 60;
  var paused = el.dataset.pause === 'true';
  var fallback = el.dataset.fallback;
  var stock = {};
  try { stock = JSON.parse(el.dataset.stock || '{}'); } catch (e) {}
  var variant = el.dataset.variant;

  function centralNow() {
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { ymd: p.year + '-' + p.month + '-' + p.day, min: (+p.hour) * 60 + (+p.minute) };
  }
  function toDate(ymd) { var a = ymd.split('-'); return new Date(Date.UTC(+a[0], a[1] - 1, +a[2])); }
  function toYmd(d) { return d.toISOString().slice(0, 10); }
  function isShipDay(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && closed.indexOf(toYmd(d)) < 0; }
  function cutLabel() {
    var h = Math.floor(cutMin / 60), m = cutMin % 60;
    return (h % 12 || 12) + (m ? ':' + String(m).padStart(2, '0') : '') + (h >= 12 ? ' PM' : ' AM');
  }

  function show(state, text) {
    el.dataset.state = state;
    el.querySelector('.rf-ship__text').textContent = text;
    el.hidden = false;
  }

  function render() {
    if (stock[variant] === false || paused) { show('fallback', fallback); return; }
    var now = centralNow();
    var today = toDate(now.ymd);
    if (isShipDay(today) && now.min < cutMin) {
      var left = cutMin - now.min;
      if (left <= countdownMin) {
        var h = Math.floor(left / 60), m = left % 60;
        show('today', 'Order in the next ' + (h ? h + 'h ' : '') + m + 'm and it ships today');
      } else {
        show('today', 'Order by ' + cutLabel() + ' CT and it ships today');
      }
      return;
    }
    for (var i = 1; i <= 14; i++) {
      var d = new Date(today.getTime() + i * 86400000);
      if (isShipDay(d)) {
        show('next', 'Order now and it ships ' + (i === 1 ? 'tomorrow' : DAYS[d.getUTCDay()]));
        return;
      }
    }
    show('fallback', fallback);
  }

  /* Track variant changes: the PDP's hidden input[name="id"] in the product form. */
  var form = el.closest('form') || document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('change', function () {
      var input = form.querySelector('[name="id"]');
      if (input && input.value) { variant = input.value; render(); }
    });
  }

  render();
  setInterval(render, 60000); /* keeps the countdown and the cutoff rollover live */
})();
